<div class="payment-success-container">
  <div class="payment-card">
    <div class="circle-icon">
        <img src="assets/images/pending.gif" alt="pending">
    </div>
    <h2>Payment Successful!</h2>
    <p>Your payment has been successfully done.</p>
    <h3>Total Payment</h3>
    <h1>${{paymentData?.amount || 'NA'}}</h1>
    <div class="payment-details">
      <div class="detail">
        <p>Ref Number</p>
        <h4>{{paymentData?.customerId || 'NA'}}</h4>
      </div>
      <div class="detail">
        <p>Payment Time</p>
        <h4>{{ paymentData ? convertToLocalTime() : '' }}</h4>
      </div>
      <div class="detail">
        <p>Payment Method</p>
        <h4>{{paymentData?.paymentMethod}}</h4>
      </div>
      <div class="detail">
        <p>Sender Name</p>
        <h4>{{paymentData?.senderName || 'NA'}}</h4>
      </div>
    </div>
  </div>
  <div class="payment-btn">
    <app-button text="Back" (onClick)="back()" class="h-100"></app-button>
  </div>
</div>
